import { useQuery } from '@tanstack/react-query'
import managerService from '@/services/api/managerService'

/**
 * Shared team-summary query.
 *
 * Used by BOTH the PL Hub page and the sidebar's "has direct reports" check.
 * Because they share the same query key, React Query dedupes them to a SINGLE
 * in-flight request (and a 5-min cache) instead of each independently fetching
 * the heavy enriched team summary — which previously fired team-summary 3x on a
 * PL Hub load (the page once + the sidebar twice via StrictMode).
 *
 * Keyed by year so a year toggle refetches, but the sidebar always asks for the
 * current year (which matches the page's default), so the common case dedupes.
 */
export function useManagerTeamSummary(employeeId: string | undefined, year: number) {
  return useQuery({
    queryKey: ['mgr-team-summary', employeeId, year],
    queryFn: () => managerService.getEnrichedTeamSummary(employeeId!),
    enabled: !!employeeId,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  })
}
